<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <!-- 개정 -->
          <c-card title="LBLREV" class="cardClassDetailForm revisionLayout" topClass="topcolor-orange" v-if="popupParam.psiLocalVentilationId">
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="row">
                  <div class="col-1">
                    <!-- 개정번호 -->
                    <c-text
                      :required="editable && isRevision"
                      :editable="editable && isRevision"
                      label="LBLREVNO"
                      name="revisionNum"
                      v-model="data.revisionNum">
                    </c-text>
                  </div>
                  <div class="col-2">
                    <!-- 개정일 -->
                    <c-text
                      :editable="false"
                      label="LBLREVPERIOD"
                      name="regDtStr"
                      v-model="data.regDtStr">
                    </c-text>
                  </div>
                  <div class="col-1">
                    <!-- 개정자 -->
                    <c-text
                      :editable="false"
                      label="LBLREVUSER"
                      name="regUserName"
                      v-model="data.regUserName">
                    </c-text>
                  </div>
                  <div class="col-4">
                    <!-- MOC 번호 -->
                    <c-moc 
                      :editable="editable"
                      :isSubmit="saveCallData"
                      :document.sync="data"
                      :documentId="data.psiLocalVentilationId"
                      documentTitle="processName"
                      mocRelatedTaskCd="RT00000001"
                      label="LBLMOCNO"
                      name="sopMocId"
                      v-model="data.sopMocId"
                    />
                  </div>
                  <div class="col-4">
                    <!-- 개정사유 -->
                    <c-text
                      :required="editable && isRevision"
                      :editable="editable && isRevision"
                      label="LBLREVREASON"
                      name="revisionContent"
                      v-model="data.revisionContent">
                    </c-text>
                  </div>
                </div>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <!-- 국소배기장치 상세정보 -->
          <c-card title="LBL0010582" class="cardClassDetailForm">
            <template slot="card-select">
              <!-- 개정이력 -->
              <c-select
                :editable="!isRevision"
                v-if="popupParam.psiLocalVentilationId"
                :comboItems="gridrev.data"
                type="custom"
                typetext="LBL0010565"
                itemText="revisionNum"
                itemValue="psiLocalVentilationId"
                name="selectedpsiLocalVentilationId"
                label=""
                v-model="selectedpsiLocalVentilationId"
                @input="rowClickRev"
              ></c-select>
            </template>
            <template slot="card-button">
              <q-btn-group outline >
                <!-- 개정 -->
                <c-btn
                  v-show="editable && popupParam.psiLocalVentilationId && !isRevision"
                  label="LBLREV"
                  icon="restart_alt"
                  @btnClicked="SetRevision" />
                <!-- 개정취소 -->
                <c-btn
                  v-show="editable && popupParam.psiLocalVentilationId && isRevision"
                  label="LBLREVCANCEL"
                  icon="restart_alt"
                  @btnClicked="CancelRevision" />
                <!-- 삭제 -->
                <c-btn
                  v-if="editable && popupParam.psiLocalVentilationId"
                  label="LBLREMOVE"
                  icon="remove"
                  @btnClicked="deleteData" />
                <!-- 저장 -->
                <c-btn
                  v-if="editable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="data"
                  :mappingType="mappingType"
                  label="LBLSAVE"
                  icon="save"
                  @beforeAction="saveData"
                  @btnCallback="saveCallback" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-6">
                <!-- 공정 또는 작업장명 -->
                <c-text
                  :required="true"
                  :editable="editable"
                  label="LBL0010609"
                  name="processName"
                  v-model="data.processName">
                </c-text>
              </div>
              <div class="col-3">
                <!-- 실내외구분 -->
                <c-text
                  :required="true"
                  :editable="editable"
                  label="LBL0010570"
                  name="inOutFlag"
                  v-model="data.inOutFlag">
                </c-text>
              </div>
              <div class="col-3">
                <c-plant
                  :required="true"
                  :editable="editable"
                  type="edit"
                  name="plantCd"
                  v-model="data.plantCd">
                </c-plant>
              </div>
              <div class="col-6">
                <!-- 발생원 -->
                <c-text
                  :required="true"
                  :editable="editable"
                  label="LBL0010571"
                  name="sourceName"
                  v-model="data.sourceName">
                </c-text>
              </div>
              <div class="col-6">
                <!-- 유해물질종류 -->
                <c-text
                  :editable="editable"
                  label="LBL0010572"
                  name="harmfulTypeCd"
                  v-model="data.harmfulTypeCd">
                </c-text>
              </div>
              <div class="col-4">
                <!-- 후드형식 -->
                <c-text
                  :editable="editable"
                  label="LBL0010573"
                  name="hoodForm"
                  v-model="data.hoodForm">
                </c-text>
              </div>
              <div class="col-4">
                <!-- 후드의제어풍속(m/s) -->
                <c-text
                  suffix="m/s"
                  :editable="editable"
                  label="LBL0010574"
                  name="hoodVelocity"
                  v-model="data.hoodVelocity">
                </c-text>
              </div>
              <div class="col-4">
                <!-- 덕트내반응속도(m/s) -->
                <c-text
                  suffix="m/s"
                  :editable="editable"
                  label="LBL0010575"
                  name="reactionVelocity"
                  v-model="data.reactionVelocity">
                </c-text>
              </div>
              <div class="col-4">
                <!-- 배풍량(㎥/min) -->
                <c-text
                  suffix="㎥/min"
                  :editable="editable"
                  label="LBL0010576"
                  name="airVolume"
                  v-model="data.airVolume">
                </c-text>
              </div>
              <div class="col-4">
                <!-- 전동기용량(Kw) -->
                <c-text
                  suffix="Kw"
                  :editable="editable"
                  label="LBL0010577"
                  name="motorVolume"
                  v-model="data.motorVolume">
                </c-text>
              </div>
              <div class="col-4">
                <!-- 전동기방폭형식 -->
                <c-text
                  :editable="editable"
                  label="LBL0010578"
                  name="motorExplosionForm"
                  v-model="data.motorExplosionForm">
                </c-text>
              </div>
              <div class="col-6">
                <!-- 공기정화장치형식 -->
                <c-textarea
                  :editable="editable"
                  :rows="3"
                  label="LBL0010579"
                  name="airCleanType"
                  v-model="data.airCleanType">
                </c-textarea>
              </div>
              <div class="col-6">
                <!-- 배기 및 처리순서 -->
                <c-textarea
                  :editable="editable"
                  :rows="3"
                  label="LBL0010580"
                  name="airExhaustOrder"
                  v-model="data.airExhaustOrder">
                </c-textarea>
              </div>
              <div class="col-6">
                <!-- 관련공정 -->
                <c-process
                  :editable="editable"
                  label="LBL0001705"
                  multiple="single"
                  name="processCd"
                  v-model="data.processCd">
                </c-process>
              </div>
              <div class="col-6">
                <!-- 관리부서 -->
                <c-dept
                  :editable="editable"
                  label="LBL0001721"
                  name="deptCd"
                  v-model="data.deptCd">
                </c-dept>
              </div>
            </template>
          </c-card>
        </div>
      </div>
      <c-dialog :param="popupOptions"></c-dialog>
    </q-form>
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'local-ven-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        psiLocalVentilationId: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      saveCallData: '',
      selectedpsiLocalVentilationId: null,
      saveUrl: transactionConfig.psi.lbe.localven.insert.url,
      mappingType: 'POST',
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
      revlistUrl: '',
      editable: true,
      isSave: false,
      isdelete: false,
      isRevision: false,
      data: {
        psiLocalVentilationId: '',  // 국소배기장치 일련번호
        plantCd: '',  // 사업장코드
        processName: '',  // 공정또는작업장명
        inOutFlag: '',  // 실내외구분
        sourceName: '',  // 발생원
        harmfulTypeCd: '',  // 유해물질종류
        hoodForm: '',  // 후드형식
        hoodVelocity: '',  // 후드의제어풍속
        reactionVelocity: '',  // 덕트내반응속도
        airVolume: '',  // 배풍량
        motorVolume: '',  // 전동기용량
        motorExplosionForm: '',  // 전동기방폭형식
        airCleanType: '',  // 공기정화장치형식
        airExhaustOrder: '',  // 배기및처리순서
        processCd: '',
        deptCd: '',
        revisionNum: '',
        groupId: '',
        sysRevision: 1,
        revisionContent: '제정',
        regDtStr: '',
        regUserName: '',
        sopMocId: ''
      },
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
      gridrev: {
        columns: [
          {
            name: 'revisionNum',
            field: 'revisionNum',
            // 개정번호
            label: 'LBLREVNO',
            align: 'center',
            style: 'width: 80px',
            sortable: true,
          },
          {
            name: 'revisionContent',
            field: 'revisionContent',
            // 개정사유
            label: 'LBLREVREASON',
            align: 'left',
            sortable: true,
          },
          {
            name: 'regDtStr',
            field: 'regDtStr',
            // 개정일시
            label: 'LBLREVPERIOD',
            style: 'width: 150px',
            align: 'center',
            sortable: true,
          },
          {
            name: 'regUserName',
            field: 'regUserName',
            // 개정자
            label: 'LBLREVUSER',
            align: 'center',
            style: 'width: 80px',
            sortable: true,
          },
        ],
        data: [],
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.psi.lbe.localven.get.url;
      this.insertUrl = transactionConfig.psi.lbe.localven.insert.url;
      this.updateUrl = transactionConfig.psi.lbe.localven.update.url;
      this.deleteUrl = transactionConfig.psi.lbe.localven.delete.url;
      this.revlistUrl = selectConfig.psi.lbe.localven.list.url + '/revs';
      this.getData();
    },
    getData() {
      this.isRevision = false;
      if (this.popupParam.psiLocalVentilationId) {
        this.getDetail(this.popupParam.psiLocalVentilationId, true);
        this.selectedpsiLocalVentilationId = this.popupParam.psiLocalVentilationId;
      }
    },
    getDetail(_psiLocalVentilationId, _check) {
      this.$http.url = this.$format(this.detailUrl, _psiLocalVentilationId);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.data = _result.data;
        // 상세팝업 최초작성/최근수정 정보 노출
        this.$emit('setRegInfo', _result.data)
        this.isRevision = false;
        if (_check) {
          this.getRevList(_result.data.groupId);
        }
        if(_result.data.psiLocalVentilationId == this.popupParam.psiLocalVentilationId) {
          this.editable = this.$route.meta.editable;
        } else {
          this.editable = false;
        }
      },);
    },
    saveData() {
      if (this.popupParam.psiLocalVentilationId) {
        this.saveUrl = this.updateUrl;
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.mappingType = 'POST';
      }
      let saveMsg = 'MSGSAVE';  // 저장하시겠습니까?
      if (this.isRevision) {
        saveMsg = 'MSGREVSAVE';
        // 현재버전을 개정하여 저장하시겠습니까?
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM', // 확인
            message: saveMsg,
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId;
              this.data.chgUserId = this.$store.getters.user.userId;
              // 개정시
              if (this.isRevision) {
                this.saveUrl = this.insertUrl;
                this.mappingType = 'POST';
                this.data.sysRevision = parseInt(this.data.sysRevision) + 1;
              }
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    deleteData() {
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',  // 확인
        message: 'MSGREMOVE', // 삭제하시겠습니까?,
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.psiLocalVentilationId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            this.isdelete = !this.isdelete;
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup');
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.popupParam.psiLocalVentilationId = result.data.psiLocalVentilationId
      this.saveCallData = uid();
      this.getData();
    },
    SetRevision() {
      this.$http.url = selectConfig.com.revision.getversion;
      this.$http.param = {revisionNum: this.data.revisionNum}
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.data.revisionNum = _result.data;
        this.data.revisionContent = '';
        this.data.regDtStr = '';
        this.data.regUserName = '';
        this.data.sopMocId = '';
        this.isRevision = true;
      });
    },
    CancelRevision() {
      this.isRevision = false;
      this.getData();
    },
    getRevList(_groupId) {
      this.$http.url = this.revlistUrl;
      this.$http.type = 'GET';
      this.$http.param = {groupId: _groupId};
      this.$http.request((_result) => {
        this.gridrev.data = _result.data;
      },);
    },
    rowClickRev(row) {
      if (row) {
        if (row != this.data.psiLocalVentilationId) {
          this.selectedpsiLocalVentilationId = row;
          this.getDetail(this.selectedpsiLocalVentilationId, false);
        }
      }
    },
  }
};
</script>
